module.exports = __webpack_public_path__ + "static/img/activityWaitIcon_moon.2906786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activityWaitIcon_moon.png
// module id = SLBn
// module chunks = 0